import { getPreference } from './preferencesHelpers';

const normalizeOpenTarget = (value, activePane = 'left') => {
  if (value === 'opposite') return activePane === 'right' ? 'left' : 'right';
  if (value === 'left') return 'left';
  if (value === 'right') return 'right';
  return activePane === 'right' ? 'right' : 'left';
};

// Determine open behavior for items coming from the left-side panels
export function computeOpenBehavior({
  type = 'doc',
  tabs = [],
  activePane = 'left',
  leftActiveTabId = null,
  rightActiveTabId = null
} = {}) {
  const key = type === 'chat' ? 'navOpenTargetChats' : type === 'version' ? 'navOpenTargetVersions' : 'navOpenTargetDocuments';
  const defaultTarget = type === 'doc' ? 'left' : 'right';
  const rawTarget = getPreference(null, key, defaultTarget);
  const preferredPane = normalizeOpenTarget(rawTarget, activePane);

  const tabMode = getPreference(null, 'navTabOpenMode', 'newTab');

  if (tabMode === 'newTab') return { mode: 'new', preferredPane };
  if (tabMode === 'replaceAnyType') return { mode: 'replace', preferredPane };

  // replaceSameType
  const focusedTabId = preferredPane === 'right' ? rightActiveTabId : leftActiveTabId;
  const activeTab = tabs.find(t => t.id === focusedTabId) || null;

  if (!activeTab) return { mode: 'new', preferredPane };

  const isActiveVersion = Boolean(activeTab.isVersion);
  const isActiveChat = activeTab.docType === 'chat';

  if (type === 'version') {
    // replace only if active is a version
    return { mode: isActiveVersion ? 'replace' : 'new', preferredPane };
  }

  if (type === 'chat') {
    return { mode: isActiveChat ? 'replace' : 'new', preferredPane };
  }

  // documents: replace only if active tab is a non-version, non-chat doc
  const isActiveDoc = !isActiveVersion && !isActiveChat;
  return { mode: isActiveDoc ? 'replace' : 'new', preferredPane };
}

const navHelpers = { computeOpenBehavior };

export default navHelpers;
